import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
//import { configure, setAddon } from '@storybook/react';
import { BreadcrumbPage } from "../../shared";
import CheckIcon from '@material-ui/icons/Check';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import { InputLabel, TextareaAutosize } from '@material-ui/core';
import Form from 'react-bootstrap/Form'
import FormControl from "@material-ui/core/FormControl";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import { getCookie } from "../../services/Cookies";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
//import {SupportFormat} from "./SupportFormat";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
//import supportuser from "./UserForm";
import grey from "@material-ui/core/colors/grey";
import clsx from "clsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import userObj from "./Userdomain";
import Select from 'react-select'
import {
  FormHelperText,
  Input,
  InputBase,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  mainBox: {
    width: "95%",
    height: "500px",
    backgroundColor: '#fff',
    marginRight: '2rem',
    marginLeft: '2rem',
    boxShadow: "0px 4px 5px -3px rgba(1,1,1,0.75)",
  },
  form: {
    textAlign: "center",
    width: '60vw',
    height: '60vh',
    position: 'absolute',
    top: "50%",
    left: "50%",
    transform: 'translate(-50%,-50%)',
    marginTop: "5rem !important"


  },
  item: {
    width: "50px",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "338px",
    "& select": {
      padding: "6px"
    }
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: "#fff",
  },
  body: {},
}))(TableCell);

const StyledSubTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: grey[400],
  },
  body: {},
}))(TableCell);

{/*Row.propTypes = {
  row: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
};*/}

function EditFunctionality(props) {
  const BreadcrumbList = [{ name: "Customer/Edit", url: "" }];
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [formObj, setFormObj] = useState(userObj);
  useEffect(() => {
    ;
    setFormObj({ domainName: props.match.params.domainName, customerName: props.match.params.customerName, status: props.match.params.status })
  }, []);

  const EditWhiteList = async (data) => {
    ////
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `CustomerDomain/UpdateDomain`;
    dispatch({ type: LOADING, payload: true });
    await postRequest(url, data)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(res);
        setFormObj({ ...formObj, domainName: '', status: '' });

        ToastSuccess('Updated Successfully')
        history.push("/dashboard/Customerdomain");
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);

      });
    ////console.log("UpdateDomain API ...................", formObj);


  }
  /* const onChangeStatus = (event) => {
   formObj.domainName = event.target.value;
   setFormObj({ ...formObj });
 }  */

  /*  const onTextChange = (event) => {
     formObj = event.target.value;
     setFormObj({ ...formObj });
     //////console.log("notesTextbox",event.target.value);
   }; */
  ////console.log(formObj, "on page load");

  const onSavedetails = () => {

    ;

      EditWhiteList({
        customerName: props.match.params.customerName,
        domainName: formObj.domainName,
        id: props.match.params.id,
        status: formObj.status

      });
    

  }
/*   const onDomainStatus = (event) => {
    ////console.log(event);

    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  }; */
   const onDomainStatus = (event) => {
     
   formObj.status = event.label; 
   setFormObj({...formObj});

 };
  const onChangeStatus = (event) => {
    formObj.domainName = event.target.value;
    setFormObj({ ...formObj });
  };
  //const defaultactiveoption=(formObj.status=="Active"?{value:1,label:'Active'}:{value:0,label:'InActive'});

  ;

  return (
    <div >

      <Box pb={3} pt={0} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      <div className={classes.mainBox}>

        <Form className={classes.form} >
          <Form.Group as={Row} className="justify-content-md-center">
            <Form.Label column sm={2}>
              Customer Name
            </Form.Label>
            <Col sm={4}>
              <Form.Control readOnly defaultValue={props.match.params.customerName} name="CustomerName" onChange={onChangeStatus} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="justify-content-md-center">
            <Form.Label column sm={2}>
              Domain Name
            </Form.Label>
            <Col sm={4}>
              <Form.Control value={formObj.domainName} name="domainName" onChange={onChangeStatus} disabled />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="justify-content-md-center">
            <Form.Label column sm={2}>
              Status
            </Form.Label>
            <Col sm={4} >

              

              <Select

                options={[{ value: 1, label: 'Active' }, { value: 0, label: 'Inactive' }]}
                value={(formObj.status == "Active" ? { value: 1, label: 'Active' } : { value: 0, label: 'Inactive' })}
                style={{ width: '100%' }}
                onChange={onDomainStatus}
                name="status"

              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="justify-content-md-center">
            <Col sm={{ span: 4, offset: 2 }}>
              <Button type="button" className={classes.btnStyle2} onClick={onSavedetails} >Save</Button>
              <Button type="button" className={classes.btnStyle2} onClick={() => {
                 history.push("/dashboard/Customerdomain");
                }} >Cancel</Button>
            </Col>

          </Form.Group>
        </Form>
      </div>

    </div>
  )
}


export default EditFunctionality

